<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增广告页
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="false"
      >
        <template
          slot="list_order"
          slot-scope="text, record"
        >
          <editable-cell
            :text="text"
            @change="onCellChange(record.id, 'list_order', $event)"
          />
        </template>
        <template
          slot="image"
          slot-scope="text, record"
        >
          <img
            :src="record.image"
            alt=""
            width="100px"
            height="100px"
          >
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider
            type="vertical"
          />
          <popconfirm-button
            :text="record.status===1?'禁用':'启用'"
            :alert-title="record.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <rank-modal
      ref="formRef"
      :btn-is-loading="btnIsLoading"
      :visible="visible"
      :title="title"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>
<script>
import { pageColumns } from '../data/index';
import RankModal from '../modal/pageModal';
export default {
  components: { RankModal },
  data() {
    return {
      btnIsLoading: false,
      columns: pageColumns,
      data: [],
      loading: false,
      visible: false,
      title: '',
      id: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({slide_id: this.$route.query.id});
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/slide/itemList',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            list_order: item.list_order,
            id: item.id,
            title: item.title,
            description: item.description,
            url: item.url,
            image: item.image_url,
            status: item.status,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 新增 编辑
    editAndAdd(record) {
      console.log('editAndAdd -> record', record);
      this.visible=true;
      if (!record.id) {
        this.title = '新增广告页';
        this.id=undefined;
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        this.id=record.id;
        this.title = '编辑广告页';
        let data={
          title: record.title,
          url: record.url,
          description: record.description,
          content: record.data.content,
          image: [
            {
              uid: record.data.image,
              url: record.data.image_url,
              name: 'img',
              status: 'done',
            },
          ],
          list_order: record.list_order,
        };
        console.log('data', data);
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确认新增
    handleSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('handleSubmit -> values', values);
          if (!err) {
            this.btnIsLoading=true;
            values.id=this.id?this.id:undefined;
            values.slide_id=this.$route.query.id;
            values.image=values.image[0].uid;
            let result = await this.$http.post(
              '/slide/itemUpdate',
              values,
            );
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.visible = false;
              this.getTableData({slide_id: this.$route.query.id});
            }
          }
        },
      );
    },
    // 取消新增
    onCancel() {
      this.visible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result = await this.$http.post('/slide/itemStatus', {
        id: record.id,
        status: record.status === 1 ? 0 : 1,
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({slide_id: this.$route.query.id});
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/slide/itemDel', {id: record.id});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({slide_id: this.$route.query.id});
      }
    },
    // 修改排序
    async onCellChange(id, key, value) {
      let result = await this.$http.post('/slide/itemOrder', {
        id: id,
        list_order: Number(value),
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({slide_id: this.$route.query.id});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
